import { Scale, Stethoscope, CarFront, Truck, ArrowUpRight } from "lucide-react";
import { Reveal, ChapterHeading } from "@/components/Reveal";

const SERVICES = [
  {
    icon: Scale,
    span: "lg:col-span-7",
    title: "Personal Injury Attorneys",
    text: "High-stakes trial lawyers across 24 states who fight for maximum policy payouts on contingency \u2014 no fee unless you win.",
    tag: "Legal Command",
    testId: "service-card-attorneys",
    img: "https://images.unsplash.com/photo-1573497620053-ea5300f94f21?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwzfHxmZW1hbGUlMjBsYXd5ZXIlMjBjb25zdWx0YXRpb258ZW58MHx8fHwxNzg5MTQxNDEwfDA&ixlib=rb-4.1.0&q=85",
  },
  {
    icon: Stethoscope,
    span: "lg:col-span-5",
    title: "Medical & Rehab Specialists",
    text: "Neurologists, orthopedic surgeons, chiropractors, and MRI centers working on medical liens so you pay $0 upfront.",
    tag: "Healing Network",
    testId: "service-card-medical",
  },
  {
    icon: CarFront,
    span: "lg:col-span-5",
    title: "Certified Auto Body Centers",
    text: "OEM-certified collision repair that insists on genuine parts and preserves your vehicle\u2019s resale value.",
    tag: "Craft Restored",
    testId: "service-card-bodyshop",
    img: "https://images.unsplash.com/photo-1727893119356-1702fe921cf9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwxfHxjYXIlMjByZXBhaXIlMjB3b3Jrc2hvcCUyMGx1eHVyeXxlbnwwfHx8fDE3ODkxNDE0MTB8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    icon: Truck,
    span: "lg:col-span-7",
    title: "Rapid Towing & Replacement Rentals",
    text: "Immediate accident-scene dispatch and direct insurance billing for rental vehicles \u2014 no out-of-pocket limbo.",
    tag: "24/7 Mobility",
    testId: "service-card-towing-rental",
  },
];

export const Services = () => (
  <section id="services" data-testid="services-section" className="scroll-mt-24 py-24 sm:py-32 px-4 sm:px-8 bg-[#071A2B]/60">
    <div className="max-w-7xl mx-auto">
      <ChapterHeading
        eyebrow="02 // COMPLETE RESOURCE ECOSYSTEM"
        title="Four Pillars of Protection Built Around Your Recovery"
        eyebrowTestId="services-chapter-num"
        titleTestId="services-headline"
      />
      <Reveal delay={0.1}>
        <p className="mt-5 max-w-2xl text-sm sm:text-base text-[#8EA3B0] leading-relaxed">
          We do not hand you a cold phonebook. We hand-select and orchestrate the right professionals
          tailored to your specific case.
        </p>
      </Reveal>
      <div className="mt-14 grid lg:grid-cols-12 gap-6">
        {SERVICES.map((s, i) => (
          <Reveal key={s.title} delay={i * 0.08} className={s.span}>
            <article
              data-testid={s.testId}
              className="group relative h-full overflow-hidden bg-[#092237] border border-[#C9A24B]/20 hover:border-[#C9A24B]/55 hover:-translate-y-1 transition-all duration-500"
            >
              {s.img && (
                <div className="relative h-44 overflow-hidden">
                  <img
                    src={s.img}
                    alt={s.title}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#092237] to-transparent" />
                </div>
              )}
              <div className="p-8">
                <div className="flex items-center justify-between">
                  <s.icon className="w-8 h-8 text-[#C9A24B] transition-transform duration-500 group-hover:scale-110" />
                  <span className="font-data text-[10px] tracking-[0.24em] uppercase text-[#0E7C86] border border-[#0E7C86]/40 rounded-full px-3 py-1">
                    {s.tag}
                  </span>
                </div>
                <h3 className="mt-5 font-editorial font-semibold text-xl sm:text-2xl text-[#FBF8F2]">{s.title}</h3>
                <p className="mt-3 text-sm text-[#8EA3B0] leading-relaxed">{s.text}</p>
                <a
                  href="#contact"
                  className="mt-6 inline-flex items-center gap-1.5 font-data text-[11px] tracking-[0.2em] uppercase text-[#C9A24B] hover:text-[#E8C87A] transition-colors duration-300"
                >
                  Request This Resource
                  <ArrowUpRight className="w-3.5 h-3.5 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </a>
              </div>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
